export const errorMessage = (message: string | undefined) :string => {
  return message === undefined ? 'This field is required.' : message
}